import {
    boolToString,
    stringToBool,
    prettyDate,
    dateToISOString,
    utcDateToISOString,
} from './utils';
import { hcpTypes } from './lookups';

type TransformRule = (input: any) => any; // eslint-disable-line @typescript-eslint/no-explicit-any

type TransformRules = {
    [key: string]: {
        load?: TransformRule;
        save?: TransformRule;
    };
};

type File = {
    category: string;
    fileName: string;
    key: string;
    uploadId: string;
    uploadedAt: string;
    expiryDate?: string;
};

const transformRules: TransformRules = {
    files: {
        load: (files: File[]): File[] =>
            files.map((file: File) => ({
                ...file,
                expiryDate: file.expiryDate ? prettyDate(file.expiryDate) : '',
            })),
        save: (files: File[]): File[] =>
            files.map((file: File) => ({
                ...file,
                expiryDate: file.expiryDate ? utcDateToISOString(file.expiryDate) : undefined,
            })),
    },
    dateOfBirth: {
        load: prettyDate,
        save: dateToISOString,
    },
    gmcRegistrationDate: {
        load: prettyDate,
        save: dateToISOString,
    },
    hasCurrentDrivingLicence: {
        load: boolToString,
        save: stringToBool,
    },
    hasCarBusinessInsurance: {
        load: boolToString,
        save: stringToBool,
    },
    hasConviction: {
        load: boolToString,
        save: stringToBool,
    },
    professionalBodyRegistrationRequired: {
        load: boolToString,
        save: stringToBool,
    },
    inNHSPension: {
        load: boolToString,
        save: stringToBool,
    },
    vatRegistered: {
        load: boolToString,
        save: stringToBool,
    },
    pensionTierDeduction: {
        save: Number,
    },
    elfhRegistered: {
        load: boolToString,
        save: stringToBool,
    },
    hcpType: {
        load: (value: string): string =>
            hcpTypes.find((hcpType) => hcpType.value === value)?.label || '',
        save: (label: string): string =>
            hcpTypes.find((hcpType) => hcpType.label === label)?.value || '',
    },
    sortCode: {
        save: (value: string): string => value.replace(/-/g, ''),
    },
};

export default transformRules;
